<template>
    <header id="header" class="header">
        <div class="clearfix hd-top">
            <a class='header_left' href="/">
                <img v-show="status==1||status==0" src="../../static/img/dayilogo2.png"/>
                <img v-show="status==-1||status==2" src="../../static/img/dayilogo2.png"/>
            </a>
        <nav class="nav clearfix">
            <ul class="nav-ul clearfix" :class="{titleStatus:status==1||status==0}">
                <li class="nav-ul-li" :class="{on:navStatus==0}"><a href="/" class="nav-title shouye"></a></li>
                <li class="nav-ul-li" :class="{on:navStatus==6}"><a href="/hall.html" class="nav-title huoyuan"></a></li>
                <li class="nav-ul-li" :class="{on:navStatus==7}"><a href="/release.html" class="nav-title fabu"></a></li>
                <li class="nav-ul-li" :class="{on:navStatus==1}" >
                    <!-- <i class="el-icon-arrow-down"></i> -->
                    <a href="/about.html#/" class="nav-title about" @mouseleave='aboutUs=false' @mouseover="aboutUs=true"></a>
                    <!-- <div class="hov-bor hov-about" :class="{aboutUs:aboutUs}">
                        <a class="hov-bor-a" href="/about.html#/0" @click="productCarou(0)">大易简介</a>
                        <a class="hov-bor-a" href="/about.html#/1" @click="productCarou(1)">我们的资质</a>
                        <a class="hov-bor-a" href="/about.html#/2" @click="productCarou(2)">联系我们</a>
                    </div> -->
                </li>
                <!-- <li class="nav-ul-li nav-ul-more" :class="{on:navStatus==2}"> -->
                <li class="nav-ul-li" :class="{on:navStatus==2}">
                    <!-- <i class="el-icon-arrow-down"></i> -->
                    <a href="/product.html#/" class="nav-title chanpin"></a>
                    <!-- <div class="hov-bor hov-news">
                        <a class="hov-bor-a" href="/product.html#/0" @click="productCarous(0,0)">全产业链产品</a>
                        <a class="hov-bor-a" href="/product.html#/1" @click="productCarous(1,0)">大易货主</a>
                        <a class="hov-bor-a" href="/product.html#/1/1" @click="productCarous(1,1)">大易运力联盟</a>
                        <a class="hov-bor-a" href="/product.html#/1/2" @click="productCarous(1,2)">大易司机</a>
                    </div> -->
                </li>
                <!-- <li class="nav-ul-li" :class="{on:navStatus==5}"><a href="/bigNews.html#/" class="nav-title dashiji"></a></li> -->
                <li class="nav-ul-li" :class="{on:navStatus==3}"><a href="/news.html#/" class="nav-title xinwen"></a></li>
                <li class="nav-ul-li" :class="{on:navStatus==4}"><a href="/joinUs.html#/" class="nav-title jiaru"></a></li>
                <!-- <li class="nav-ul-li" @mouseover="secondShow=6"><span>工作机会</span></li> -->
            </ul>

        </nav>
        </div>
    </header>
</template>

<script>
import { gb2big5 } from '@/utils/gb2big5.js'
export default {
    name: 'pubheader',
    data () {
        return {
            userName: '',
            hdsearch:'',
            secondShow:0,
            searchStatus:false,
            yuyan:0,
            url: '/sso.html#/',
            navStatus:0,
            hdsearchStatus:false,
            current:'',
            status:-1,
            aboutUs:false,
        }
    },
    mounted () {
        // gb2big5();
        let pathname = location.pathname;
        if(pathname=='/' || pathname==''){
            this.navStatus=0;
        }else if(pathname=="/about.html"){
            this.navStatus=1;
        }else if(pathname=="/product.html"){
            this.navStatus=2;
        }else if(pathname=="/news.html"){
            this.navStatus=3;
        }else if(pathname=="/joinUs.html"){
            this.navStatus=4;
        }else if(pathname=="/newsDetail.html"){
            this.navStatus=3;
        }else if(pathname=="/jobDetail.html"){
            this.navStatus=4;
        }else if(pathname=="/result.html"){
            this.navStatus=4;
        }else if(pathname=="/bigNews.html"){
            this.navStatus=5;
        }else if(pathname=="/hall.html"){
            this.navStatus=6;
        }else if(pathname=="/release.html"){
            this.navStatus=7;
        }
        // else if(pathname=="/culture.html"){
        //     this.navStatus=5;
        // }
        var self = this
        if (
            '-ms-scroll-limit' in document.documentElement.style &&
            '-ms-ime-align' in document.documentElement.style
        ) {
            // detect it's IE11
            window.addEventListener(
                'hashchange',
                function (event) {
                    var currentPath = window.location.hash.slice(1)
                    // if (store.state.route.path !== currentPath) {
                    self.$router.push(currentPath)
                    // }
                },
                false
            )
        };
        // this.$bus.$on('active',val=>{
        //     console.log(val);
        // })
            //  this.current = localStorage.getItem('routerPathFrom');
    },
    watch:{

    },
    methods: {
        productCarous(num,nb){
            this.$parent.carouPage(num,nb)
        },
        productCarou(num){
            this.$parent.carouPage(num)
        },
        mousestatus(){
            this.secondShow = this.navStatus;
        },
       changeHeard(status){
           // console.log(status)
           this.status = status
       }
    },
    updated(){

    }

}
</script>

<style>
/* @import url("../../static/css/animate.min.css"); */
.hdsearchStatus .el-input__inner{
    border-color: #008EDD;
    border-width: 2px;
}
.header{
    background-color: #f5f5f5;
}
.hd-search-input{
    width: 37px;
    display: inline-block;
    float: left;
    overflow: hidden;
}
.showSearch{
    animation:showSearch .5s ;
    width: 150px;
}
.hideSearch{
    animation:hideSearch .5s ;
    width: 0px;
}
.nav-ul-li a{
    color: rgba(0,0,0,0.85);
}
@keyframes showSearch
{
from {width:37px;}
to {width:150px;}
}
@keyframes hideSearch
{
from {width:150px;}
to {width:0px;}
}
.header {width: 100%;box-sizing: border-box;
/* max-width: 1180px; */
min-width: 900px;;margin: 0 auto;position: fixed;top: 0;z-index: 999;}
.header .header_left{ float: left; margin-top: 10px;margin-top: 34px;margin-left: 80px;display: block;}
.header .header_left img{ height: 47px;}

.header .header_right{ float: right; color: #CCCCCC; padding-top: 17px;position: relative;}
.header .header_right img{ display: inline-block; vertical-align: middle;}
.header .header_right a{ color: #CCCCCC; }
.mockapp,.eb-tianruigroup,.email-tianruigroup,.search,.yuyan_tianruigroup{
    background: url(../../static/img/doc.svg) center no-repeat;
    display: inline-block;
    width: 34px;
    height: 34px;
    border: 1px solid #CCCCCC;
    border-radius: 5px;
    margin-left: 15px;
    background-size: 20px 20px;
}
.email-tianruigroup{
    background-size: 20px 16px;
}
.yuyan-change{
    background: url(../../static/img/jian.svg) center no-repeat;
    display: block;
    width: 32px;
    height: 33px;
    border: 2px solid #CCCCCC;
    border-radius: 5px;
    margin-bottom: 10px;
}
.yuyan-change:hover{
    background-image: url(../../static/img/jian_black.svg);
}
.search{
    background-image: url(../../static/img/search.svg);
    border: none;
    position: absolute;
    right: 206px;
    top: 19px;
    background-color: #fff;
    z-index: 9;
    height: 33px;
    width: 34px;
}
.search:hover{
    background-image: url(../../static/img/search_ho.svg) ;
    background-size: 22px 22px;
}
.search_black{
    background-image: url(../../static/img/search_black.svg) ;

}
.search_black.search:hover{
    background-image: url(../../static/img/search_black.svg) ;
    background-size: 22px 22px;
}
.hd-search-input .el-input__inner{
    height: 37px;
    line-height: 37px;
}
.eb-tianruigroup{
    background-image: url(../../static/img/e.svg);
}
.eb-tianruigroup:hover{
    background-image: url(../../static/img/e_black.svg);
     background-size: 22px 22px;
}
.email-tianruigroup{
    background-image: url(../../static/img/youxiang.svg);
}
.email-tianruigroup:hover{
    background-image: url(../../static/img/youxiang_black.svg);
     background-size: 22px 18px;
}
.mockapp{
    background-size: 18px 18px;
}
.mockapp:hover{
    background-image: url(../../static/img/doc_black.svg);
    background-size: 20px 20px;
}
.yuyan_tianruigroup{
    background-image: url(../../static/img/jian.svg);
    background-size: 16px 16px;
}
.yuyan_tianruigroup:hover{
    background-image: url(../../static/img/jian_black.svg);
}
.fanti{
    background-image: url(../../static/img/fan.svg);
}
.fanti:hover{
    background-image: url(../../static/img/fan_black.svg);
}
.English{
    background-image: url(../../static/img/En.svg);
}
.header .header_right .loginOut{ background: url('../assets/icon_loginout.png') no-repeat left center;padding-left: 30px; height: 30px; line-height: 30px; margin: 17px 0;}
.hd-top{


    height: 120px;
}
.hd-top::before {
    content: '';
    border-bottom: 1px solid #000;
    opacity: 0.1;
    height: 120px;
    width: 100%;
    display: block;
    position: absolute;
    top: 0;
    z-index: -1;
}
.nav{
    padding-top: 38px;
    float: right;
    margin-right: 80px;
    /* position: relative; */
}
.nav-ul{
    /* display: flex; */
    padding-bottom: 20px;
}
.nav-ul-li{
    float: left;
    font-size: 16px;
    color: #000;
    line-height: 21px;
    /* margin-right: 18px; */
    font-weight: 600;
    cursor: pointer;
    position: relative;
    padding: 9px 19px;
}
.shouye{ 
    background-image: url('../../static/img/zhuye_h.svg');
    width: 31px;
    height: 16px;
}
.titleStatus .shouye{
    background-image: url('../../static/img/zhuye_b.svg');
}
.shouye:hover{
    background-image: url('../../static/img/zhuye_l.svg');
}
.nav-ul-li.on a.shouye:hover{
    background-image: url('../../static/img/zhuye_b.svg')
}
.nav-ul-li.on a.shouye{
    background-image: url('../../static/img/zhuye_b.svg')
}
.huoyuan{ 
    background-image: url('../../static/img/car_h.svg');
    width: 105px;
    height: 16px;
}
.titleStatus .huoyuan{
    background-image: url('../../static/img/car_b.svg');
}
.huoyuan:hover{
    background-image: url('../../static/img/car_l.svg');
}
.nav-ul-li.on a.huoyuan:hover{
    background-image: url('../../static/img/car_b.svg')
}
.nav-ul-li.on a.huoyuan{
    background-image: url('../../static/img/car_b.svg')
}
.fabu{ 
    background-image: url('../../static/img/fabu_h.svg');
    width: 71px;
    height: 16px;
}
.titleStatus .fabu{
    background-image: url('../../static/img/fabu_b.svg');
}
.fabu:hover{
    background-image: url('../../static/img/fabu_l.svg');
}
.nav-ul-li.on a.fabu:hover{
    background-image: url('../../static/img/fabu_b.svg')
}
.nav-ul-li.on a.fabu{
    background-image: url('../../static/img/fabu_b.svg')
}
.about{
    background-image: url('../../static/img/about_h.svg');
    width: 63px;
    height: 16px;
}
.titleStatus .about{
    background-image: url('../../static/img/about_b.svg');
}
.about:hover{
    background-image: url('../../static/img/about_l.svg');
}
.nav-ul-li.on a.about:hover{
    background-image: url('../../static/img/about_b.svg')
}
.nav-ul-li.on a.about{
    background-image: url('../../static/img/about_b.svg')
}
.chanpin{
    background-image: url('../../static/img/chanpin_h.svg');
    width: 63px;
    height: 16px;
}
.titleStatus .chanpin{
    background-image: url('../../static/img/chanpin_b.svg');
}
.chanpin:hover{
    background-image: url('../../static/img/chanpin_l.svg');
}
.nav-ul-li.on a.chanpin:hover{
    background-image: url('../../static/img/chanpin_b.svg')
}
.nav-ul-li.on a.chanpin{
    background-image: url('../../static/img/chanpin_b.svg')
}
.xinwen{
    background-image: url('../../static/img/xinwen_h.svg');
    width: 63px;
    height: 16px;
}
.titleStatus .xinwen{
    background-image: url('../../static/img/xinwen_b.svg');
}
.xinwen:hover{
    background-image: url('../../static/img/xinwen_l.svg');
}
.nav-ul-li.on a.xinwen:hover{
    background-image: url('../../static/img/xinwen_b.svg')
}
.nav-ul-li.on a.xinwen{
    background-image: url('../../static/img/xinwen_b.svg')
}

.dashiji{
    background-image: url('../../static/img/dashiji_h.svg');
    width: 63px;
    height: 16px;
}
.titleStatus .dashiji{
    background-image: url('../../static/img/dashiji_b.svg');
}
.dashiji:hover{
    background-image: url('../../static/img/dashiji_l.svg');
}
.nav-ul-li.on a.dashiji:hover{
    background-image: url('../../static/img/dashiji_b.svg')
}
.nav-ul-li.on a.dashiji{
    background-image: url('../../static/img/dashiji_b.svg')
}
.jiaru{
    background-image: url('../../static/img/jiaru_h.svg');
    width: 63px;
    height: 16px;
}
.titleStatus .jiaru{
    background-image: url('../../static/img/jiaru_b.svg');
}
.jiaru:hover{
    background-image: url('../../static/img/jiaru_l.svg');
}
.nav-ul-li.on a.jiaru:hover{
    background-image: url('../../static/img/jiaru_b.svg')
}
.nav-ul-li.on a.jiaru{
    background-image: url('../../static/img/jiaru_b.svg')
}
.nav-ul-li a,.nav-ul-li span{
    font-size: 16px;
    cursor: pointer;
}
.nav-ul-li:hover,.nav-ul-li a:hover{
    /* color: #008EDD; */
}
.bor-top2{
    border-top: 2px solid #008EDD;
    position: absolute;
    left: 0;
    top: 142px;
    width: 100%;
}
.nav-ul-list{
    /* border-top: 2px solid #008EDD; */
    height: 0px;
    overflow: hidden;
}

.hei100{
    /* height: 100px; */
    animation:mymove .5s ;
    -webkit-animation:mymove .5s ; /*Safari and Chrome*/
    height: 56px;
    line-height: 56px;
}
@keyframes mymove
{
from {height:0px;}
to {height:56px;}
}

@-webkit-keyframes mymove /*Safari and Chrome*/
{
from {height:0px;}
to {height:56px;}
}
.nav-ul-li.on,.nav-ul-li .on{
    color: #fff;
    background-color: #0066FF;
    border-radius: 20px;

}
.nav-ul-li.on a{
color: #fff;
    /* background-color: #0066FF; */
}
@keyframes hovHoverOut {
    form{
        opacity: 1;
        display: block;
        transform:translateX(-30px);
    }
    to{
        opacity: 0;
        transform:translateX(-100px);
        /* display: none; */
    }
}
.hov-bor{
    position: absolute;
    top: 45px;
    left: -16px;
    width: 190px;
    height: 3px;
    /* transition: 0.5s; */
    /* transform:translateX(-100px); */
    background-color: #0066FF;
    /* animation: hovHoverOut 0.3s; */
    /* transition: all 0.3s; */
    /* transition-timing-function:linear; */
    visibility: hidden;
    opacity: 0;
    border-radius: 10px;
    filter: "alpha(opacity=0)";
    z-index: 999;
}
.hov-news{
    height: 204px;
}
.hov-about{
    height: 152px;
}
.hov-bor::before{
    content: '';
    background-image: url('../../static/img/nav_bk.svg');
    background-repeat: no-repeat;
    background-position: left top;
    position: absolute;
    top: -11px;
    left: 0;
    z-index: -1;
    height: 100%;
    width: 100%;
}
.hov-bor a{
    display: block;
    color: #fff;
    line-height: 50px;

    padding-left: 60px;
    font-size: 14px;
}

.hov-about .hov-bor-a:nth-child(1){
    background-image: url('../../static/img/dayi_bigthing.svg');
}
.hov-about .hov-bor-a:nth-child(2){
    background-image: url('../../static/img/dayi_info.svg');
    background-position: 17px center;
}
.hov-about .hov-bor-a:nth-child(3){
    background-image: url('../../static/img/dayi_us.svg');
}
.hov-bor-a:hover{
    background:rgba(0,0,0,0.1);
    background-position: 14px center;
    background-repeat: no-repeat;
    border-radius: 10px;
}
.hov-news .hov-bor-a:nth-child(1){
    background-image: url('../../static/img/allComp.svg');
}
.hov-news .hov-bor-a:nth-child(2){
    background-image: url('../../static/img/dayi_pc.svg');
}
.hov-news .hov-bor-a:nth-child(3){
    background-image: url('../../static/img/dayi_mb.svg');
    background-position: 17px center;
}
.hov-news .hov-bor-a:nth-child(4){
    background-image: url('../../static/img/dayi_mb.svg');
    background-position: 17px center;
}
.hov-bor a:nth-child(n+2){
    border-top: 1px solid rgba(0,0,0,0.10);
}
.nav-ul-li:hover{
    color: #0066FF;
    /* background: #0066FF; */
    border-radius: 20px;
}
a.hov-bor-a{
    background-position: 14px center;
    background-repeat: no-repeat;
}
.nav-ul-li:hover .nav-title{
    color: #0066FF;
}
.nav-title{
    color: #0066FF;
        background-position: center;
    background-repeat: no-repeat;
    display: block;
}
.nav-ul-li.on:hover .nav-title,.nav-ul-li.on:hover .el-icon-arrow-down,.nav-ul-li.on .el-icon-arrow-down{
    color: #fff;
}
.on .hov-bor{
    /* opacity: 1;
    transform:translateX(-30px);
    color: #fff; */
}
@keyframes hovHover {
    from{
        
        transform:translateX(-100px);
        opacity: 0;
    }
    to{
        transform:translateX(-30px);
        opacity: 1;
    }
}
.nav-ul-more:hover .hov-bor{
    visibility: visible;
    transform:translateX(-30px);
    animation: hovHover 0.3s ;
    opacity: 1;
    
}
.hov-bor.aboutUs{
    /* transform:translateX(-30px);
    opacity: 1;
    display: block; */
    /* visibility: visible;
    transform:translateX(-30px);
    animation: hovHover 0.3s;
    opacity: 1 !important; */
}
.titleStatus .nav-ul-li .hov-bor{
/* background-color: #fff; */
}
.second-list{
    position: relative;
    overflow: hidden;
    height: 56px;
}
.second-list .nav-ul-list-li{
    display: inline-block;
    font-size: 14px;
    color: #999999;
    margin-right: 40px;
    line-height: 56px;
}
.second-list .nav-ul-list-li:hover{
    color: #333;
}
.second-list a.selected{
    color: #333;
}
.hdsearchStatus .search{

}
.yuyanList{
    position: relative;
    border-width: 1px;
    border-color: #fff;
}
.yuyanList:hover{
    border-color: #ccc;
    border-bottom-color: #fff;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;

}
.yuyanList:hover #gb2big5{
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
}
.yuyanList #gb2big5{
    display: block;
    border: 1px solid #CCCCCC;
    /* width: 100%; */
    /* HEIGHT: 100%; */
    BORDER-RADIUS: 4PX;
    width: 32px;
    height: 32px;
}
.yuyanList:hover .yuyan-type{
    display: block;
}
.yuyan-type{
    display: none;
}
.yuyan-type .yuyan-change{
    position: absolute;
    top: 34px;
    right: -1px;
    border-top-width: 0;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    background-color: #fff;
}
.titleStatus .nav-ul-li a,.titleStatus .nav-ul-li span{
    color: #fff;
}

.onHeader{
    background-color: #FFF;
}
.nav-ul-li .el-icon-arrow-down{
    position: absolute;
    right: 11px;
    color: #000;
    top: 8px;
}
.el-icon-arrow-down:before{
    font-size: 12px;
}
.titleStatus .nav-ul-li .el-icon-arrow-down{
    color: #fff;
}
.nav-ul-li:hover .el-icon-arrow-down{
    color: #0066FF;
}
.nav-ul-more{
    padding-right: 29px;
}
@media screen and (max-width:1100px) {
    .nav{
        margin-right: 50px;
    }
    .header .header_left,.ft-footer{
        margin-left: 50px !important;
    }
}
</style>
